var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotiWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5522_46240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3332C5.40484 18.3332 1.6665 14.5957 1.6665 9.99984C1.6665 5.40484 5.40484 1.6665 9.99984 1.6665C14.5948 1.6665 18.3332 5.40484 18.3332 9.99984C18.3332 14.5957 14.5948 18.3332 9.99984 18.3332ZM9.99984 3.33317C6.324 3.33317 3.33317 6.324 3.33317 9.99984C3.33317 13.6757 6.324 16.6665 9.99984 16.6665C13.6757 16.6665 16.6665 13.6757 16.6665 9.99984C16.6665 6.324 13.6757 3.33317 9.99984 3.33317Z",
    fill: "#D6341E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 5H9.1665V10.8333H10.8332V5Z",
    fill: "#D6341E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 14.3748C10.575 14.3748 11.0413 13.9085 11.0413 13.3332C11.0413 12.7579 10.575 12.2915 9.99967 12.2915C9.42438 12.2915 8.95801 12.7579 8.95801 13.3332C8.95801 13.9085 9.42438 14.3748 9.99967 14.3748Z",
    fill: "#D6341E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5522_46240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiWarning);
export default __webpack_public_path__ + "static/media/noti_warning.39c7919a96e54dddca59ec3474fa7ec3.svg";
export { ForwardRef as ReactComponent };